(function () {
  'use strict';

  var component = {
    template:'<hq-tools-lighting-header></hq-tools-lighting-header><hq-tools-lighting-wizard-bar></hq-tools-lighting-wizard-bar><div class="hq-lighting-step"><hq-tools-lighting-title id="desc-question-fixture" translate-key="FIXTURE"></hq-tools-lighting-title><div class="hq-lighting-step__content hq-lighting-step__content--selection"><div class="hq-lighting-list" data-ng-class="{isCentered: $ctrl.options.length <= 2}" aria-label="{{\'FIXTURE_TITLE\' | translate}}" aria-labelledby="desc-question-fixture" role="radiogroup"><hq-tools-lighting-list-item ng-repeat="option in $ctrl.options" option="option" step-name="fixture" on-change="$ctrl.onChange(value)" selection="$ctrl.selection"></hq-tools-lighting-list-item></div></div><hq-tools-lighting-footer translate-key="CONTINUE" disabled="{{!$ctrl.isValid}}" sref="base" lref="room" sticky="{{$ctrl.isValid}}"></hq-tools-lighting-footer></div>',
    controller: StepFixtureController,
  };

  function StepFixtureController(hqTLightingOptions) {
    'ngInject';

    var ctrl = this;

    ctrl.options = hqTLightingOptions.fixtures;
    ctrl.selection = hqTLightingOptions.fixtureSelection;
    if (ctrl.selection === null) {
      ctrl.isValid = false;
    } else {
      ctrl.isValid = true;
    }

    ctrl.onChange = function (value) {
      ctrl.selection = value;
      hqTLightingOptions.fixtureSelection = value;
      ctrl.isValid = true;
    };
  }

  angular
    .module('hq.tools.lighting')
    .component('hqToolsLightingStepFixture', component);
}());
